import EditIcon from "@mui/icons-material/Edit";
import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { getDiagnosticTemplates } from "../../../redux/reducers/clinicSlice";
import { deleteTreatmentPlanById } from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import { eyeBtn } from "../../../util/CommonIconStyle";
import { diagTemplateTypes } from "../../../util/dropList";
import DiagnosticTemplateCreate from "./DiagnosticTemplateCreate";

const tableHeader = ["templateName", "createdBy", "lastUpdated", "extraStatus"];
const initValues = {
  visible: false,
  name: "",
  type: "parameter",
  error: false,
};

const DiagnosticTemplate = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [createValues, setCreateValues] = useState(initValues);
  const [createVsble, setCreateVsble] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [delModVsble, setDelModVsble] = useState(false);
  const [selectedTemp, setSelectedTemp] = useState(null);
  const { diagnosticTemplates } = useSelector((state) => state?.clinic);
  const itemsPerLoad = 10;

  useEffect(() => {
    onApiCall(1);
  }, [searchValue]);

  const onApiCall = (pge = 1, url = "") => {
    setPage(pge);
    const baseQuery = `?page=${pge}&itemSize=${itemsPerLoad}${searchValue?.length > 0 ? `&search=${searchValue}` : ""}`;
    dispatch(getDiagnosticTemplates(baseQuery));
  };

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleDelete = (det) => {
    setSelectedTemp(det);
    setDelModVsble(true);
  };

  const handleEdit = (det) => {
    setSelectedTemp(det);
    setCreateVsble(true);
  };

  const handleCloseDel = () => {
    setSelectedTemp(null);
    setDelModVsble(false);
  };

  const handleConfirmDel = () => {
    dispatch(deleteTreatmentPlanById(selectedTemp?.templateId)).then((res) => {
      if (res?.payload) {
        onApiCall();
        dispatch(getDiagnosticTemplates());
        handleCloseDel();
      }
    });
  };

  const getTableList = () => {
    return (diagnosticTemplates?.list ?? [])?.map((pln) => ({
      templateName: pln?.templateName,
      createdBy: pln?.clinicId,
      lastUpdated: moment(new Date(pln?.createdDate)).format("DD MMM YYYY"),
      extraStatus: (
        <div className="flex-row">
          {/* <div className="cursor" onClick={() => handleDelete(pln)}>
            <div className="flex-center">
              <DeleteOutlineIcon sx={delBtn} />
            </div>
            <Typography className="red3 fs8 txt-semi-bold text-align-center">
              Delete
            </Typography>
          </div> */}
          <div className="cursor ml10" onClick={() => handleEdit(pln)}>
            <div className="flex-center">
              <EditIcon sx={eyeBtn} />
            </div>
            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
              Edit
            </Typography>
          </div>
        </div>
      ),
    }));
  };

  const handleCreate = () => {
    setCreateValues({ ...createValues, visible: true });
    // setSelectedTemp(null);
    // setCreateVsble(true);
  };

  const onNext = () => {
    if (createValues?.name?.length === 0 || !createValues?.name) {
      return setCreateValues({ ...createValues, error: true });
    }
    setCreateVsble(true);
    setSelectedTemp({
      templateName: createValues?.name,
      type: createValues?.type,
    });
    setCreateValues(initValues);
  };

  const onCloseCreateMod = () => {
    setCreateValues(initValues);
  };

  const onCreateValueChange = (name, value) => {
    const reqObj = { ...createValues, [name]: value };
    if (name === "name") {
      reqObj.error = value?.length > 0 ? false : true;
    }
    setCreateValues(reqObj);
  };

  return (
    <>
      {createVsble ? (
        <DiagnosticTemplateCreate
          setCreateVsble={setCreateVsble}
          selectedTemp={selectedTemp}
          setSelectedTemp={setSelectedTemp}
        />
      ) : null}
      {!createVsble && (
        <div>
          <div className="flex-row-ali-cen flex-center mt5">
            <div className="w30Per">
              <CustomTextField
                placeholder="Search"
                name="name"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
                backgroundColor={AppColors.lightBlue2}
              />
            </div>
            <div className="ml20">
              <CustomButton text="Create" onClick={handleCreate} smallBtn />
            </div>
          </div>

          <CustomTable
            columns={tableHeader}
            datas={getTableList()}
            grey
            page={page}
            rowsPerPage={itemsPerLoad}
            totalRecords={diagnosticTemplates?.totalRecords ?? 0}
            handleChangePage={handleChangePage}
            maxHeight="70vh"
          />
        </div>
      )}
      {createValues?.visible ? (
        <CustomModal
          open={createValues?.visible}
          onClose={onCloseCreateMod}
          header="Create"
          rightModal
          modalWidth={30}
        >
          <div className="ph20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 blue-color">
                  Template Name <span className="red-color">*</span>
                </div>
                <CustomTextField
                  value={createValues?.name}
                  handleChange={(e) =>
                    onCreateValueChange("name", e?.target?.value)
                  }
                  fullWidth
                  error={createValues?.error}
                  helperText={
                    createValues?.error ? "This field is required" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 blue-color">
                  Type <span className="red-color">*</span>
                </div>
                <CustomSelect
                  list={diagTemplateTypes}
                  value={createValues?.type}
                  handleChange={(e) =>
                    onCreateValueChange("type", e?.target?.value)
                  }
                  select
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex1-end mt10">
                  <div>
                    <CustomButton text="Save" smallBtn onClick={onNext} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </CustomModal>
      ) : null}
      <CustomModal
        open={delModVsble}
        onClose={handleCloseDel}
        header="Delete"
        modal
        modalWidth={30}
      >
        <div className="ml10">Are you sure want to delete the template?</div>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDel} smallBtn />
          </div>
          <div className="ml20">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDel}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DiagnosticTemplate;
